import type { Direction, State, InvoiceListFilters } from '../../api/invoices.js';

const DIRECTION_LABEL_FR: Record<Direction, string> = {
  INBOUND: 'Reçues',
  OUTBOUND: 'Émises',
  OFF_PLATFORM: 'Hors plateforme',
};

// Only the most useful states are surfaced as pills. Full enum is still
// supported via the URL — these are the 4-5 buckets a comptable scans daily.
const STATE_PILLS: { value: State; label: string }[] = [
  { value: 'RECEIVED', label: 'Reçues' },
  { value: 'AVAILABLE', label: 'Disponibles' },
  { value: 'ACKNOWLEDGED', label: 'Accusées' },
  { value: 'REJECTED', label: 'Rejetées' },
];

interface Props {
  filters: InvoiceListFilters;
  onChange: (next: InvoiceListFilters) => void;
}

export function FilterPills({ filters, onChange }: Props) {
  function toggleState(s: State) {
    const has = filters.states.includes(s);
    const next = has ? filters.states.filter((x) => x !== s) : [...filters.states, s];
    onChange({ ...filters, states: next });
  }
  function clearStates() {
    onChange({ ...filters, states: [] });
  }
  return (
    <div className="invoices__filters" role="toolbar" aria-label="Filtres">
      <div className="invoices__filter-group">
        <span className="eyebrow">Direction</span>
        <button
          type="button"
          className={`pill-btn${filters.direction === null ? ' is-active' : ''}`}
          onClick={() => onChange({ ...filters, direction: null })}
          data-testid="direction-pill-ALL"
        >
          Toutes
        </button>
        {(Object.keys(DIRECTION_LABEL_FR) as Direction[]).map((d) => (
          <button
            key={d}
            type="button"
            className={`pill-btn${filters.direction === d ? ' is-active' : ''}`}
            onClick={() => onChange({ ...filters, direction: filters.direction === d ? null : d })}
            data-testid={`direction-pill-${d}`}
          >
            {DIRECTION_LABEL_FR[d]}
          </button>
        ))}
      </div>

      <div className="invoices__filter-group">
        <span className="eyebrow">État</span>
        <button
          type="button"
          className={`pill-btn${filters.states.length === 0 ? ' is-active' : ''}`}
          onClick={clearStates}
          data-testid="state-pill-ALL"
        >
          Tous
        </button>
        {STATE_PILLS.map(({ value, label }) => (
          <button
            key={value}
            type="button"
            className={`pill-btn${filters.states.includes(value) ? ' is-active' : ''}`}
            onClick={() => toggleState(value)}
            data-testid={`state-pill-${value}`}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
